"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMain;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */
function UIMain(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      use = _ref.use,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "children", "flush", "use"]);
  var classes = (0, _classNames.default)('private-main', className, {
    'private-main--flush': flush,
    'private-main--dark': use === 'dark'
  });
  return _react.default.createElement("main", (0, _extends2.default)({}, other, {
    className: classes
  }), children);
}

UIMain.propTypes = {
  children: _react.PropTypes.node.isRequired,
  flush: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(['standard', 'dark'])
};
UIMain.displayName = 'UIMain';
module.exports = exports.default;